import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { Menu, X, ShieldCheck } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Why Alpha", to: "why-alpha" },
    { name: "About Us", to: "about-us" },
    { name: "Services", to: "services" },
    // { name: "Testimonials", to: "testimonials" },
    // { name: "Contact", to: "contact" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md py-4" : "bg-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-6 flex justify-between items-center">
        <div className="flex items-center gap-2 cursor-pointer">
          {scrolled ? (
            <img src={"/alpha_logo.png"} alt="Alpha" className="w-10 h-10" />
          ) : (
            <img
              src={"/alpha_logo_white.png"}
              alt="Alpha"
              className="w-10 h-10"
            />
          )}
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.to}
              smooth={true}
              duration={500}
              className={`cursor-pointer font-medium hover:text-secondary transition-colors ${
                scrolled ? "text-slate-600" : "text-slate-200"
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="contact"
            smooth={true}
            duration={500}
            className="bg-secondary hover:bg-primary text-white px-6 py-2 rounded-full font-semibold transition-all transform hover:scale-105 cursor-pointer"
          >
            Contact Us{" "}
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={`relative z-50 p-2 rounded-lg transition-all duration-300 ${
              scrolled ? "text-primary hover:bg-slate-100" : "text-white hover:bg-white/10"
            }`}
            aria-label="Toggle menu"
          >
            <div className="relative w-7 h-7">
              <span
                className={`absolute top-0 left-0 w-full h-0.5 bg-current transition-all duration-300 ${
                  isOpen ? "rotate-45 top-3" : ""
                }`}
              ></span>
              <span
                className={`absolute top-3 left-0 w-full h-0.5 bg-current transition-all duration-300 ${
                  isOpen ? "opacity-0" : "opacity-100"
                }`}
              ></span>
              <span
                className={`absolute top-6 left-0 w-full h-0.5 bg-current transition-all duration-300 ${
                  isOpen ? "-rotate-45 top-3" : ""
                }`}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/50 z-40 top-20 transition-opacity duration-300"
          onClick={() => setIsOpen(false)}
        ></div>
      )}

      {/* Mobile Menu */}
      <div
        className={`md:hidden fixed top-20 left-0 w-full bg-white shadow-2xl z-40 transition-all duration-300 ease-in-out ${
          isOpen
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-4 pointer-events-none"
        }`}
      >
        <div className="container mx-auto px-6 py-6 flex flex-col gap-2">
          {navLinks.map((link, index) => (
            <Link
              key={link.name}
              to={link.to}
              smooth={true}
              duration={500}
              onClick={() => setIsOpen(false)}
              className="text-slate-800 font-medium text-lg py-3 px-4 rounded-lg hover:bg-slate-50 hover:text-primary transition-all duration-200 border-b border-slate-100 last:border-0"
              style={{
                animationDelay: isOpen ? `${index * 50}ms` : "0ms",
                animation: isOpen ? "slideInLeft 0.3s ease-out forwards" : "none",
              }}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="contact"
            smooth={true}
            duration={500}
            onClick={() => setIsOpen(false)}
            className="bg-secondary hover:bg-primary text-white text-center py-3 px-4 rounded-lg font-bold mt-2 transition-all duration-200 transform hover:scale-105 shadow-md"
            style={{
              animationDelay: isOpen ? `${navLinks.length * 50}ms` : "0ms",
              animation: isOpen ? "slideInLeft 0.3s ease-out forwards" : "none",
            }}
          >
            Contact Us
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
